import script from "./GoToLinkBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./GoToLinkBtn.vue?vue&type=script&setup=true&lang=js"

import "./GoToLinkBtn.vue?vue&type=style&index=0&id=ba11cfbc&lang=scss&scoped=true"

import exportComponent from "/Users/rioschan/Downloads/event-2022electrolux-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba11cfbc"]])

export default __exports__